/**
 * TEMPORARY — prototype / non-affiliation notices.
 *
 * Everything here is controlled by `src/config/prototype.json`. To remove all
 * notices, set `"enabled": false` there (the build also stops adding the
 * noindex tag and "(Prototype)" title suffix). To remove the code entirely,
 * delete this file, its CSS module, prototype.json, and the <Prototype…/>
 * usages in App.tsx and ContactPage.tsx, and keep a plain "Site by Reints Labs"
 * credit in Footer.tsx in place of <StudioCredit />.
 */
import config from '../config/prototype.json';
import styles from './Prototype.module.css';

function BuiltBy() {
  return (
    <a href={config.builtByUrl} target="_blank" rel="noopener noreferrer">
      {config.builtBy}
    </a>
  );
}

/** Thin bar above the site header, on every page. */
export function PrototypeBanner() {
  if (!config.enabled) return null;
  return (
    <div className={styles.banner} role="note" aria-label="Prototype notice">
      <strong>Prototype website.</strong> A concept built by <BuiltBy />. Not affiliated
      with, endorsed by, or operated by {config.notAffiliatedWith}.
    </div>
  );
}

/**
 * Studio credit for the footer's last line (Reints Labs standard, docs/STUDIO-CREDIT.md).
 * While prototype mode is on it also carries the non-affiliation and sample-content
 * notice, since this prototype was not commissioned by the company it depicts.
 */
export function StudioCredit() {
  const studio = (
    <a href={config.builtByUrl} target="_blank" rel="noopener noreferrer">
      Reints Labs
    </a>
  );
  if (!config.enabled) return <>Site by {studio}</>;
  return (
    <>
      Prototype by {studio}, not affiliated with {config.notAffiliatedWith}. Details shown
      are sample content.
    </>
  );
}

/** Tells people who is actually receiving their message. */
export function PrototypeContactNote() {
  if (!config.enabled) return null;
  return (
    <p className={styles.contactNote} role="note">
      <strong>Prototype notice:</strong> messages sent from this page go to{' '}
      {config.builtBy}, the studio building this prototype — not to{' '}
      {config.notAffiliatedWith}.
    </p>
  );
}
